import { Checkbox, FormControlLabel, Typography } from "@mui/material";

type Props = {
  currentBlock: any;
};

const CheckboxFieldPreview = ({ currentBlock }: Props) => {
  const label = currentBlock?.label;
  const optional = currentBlock?.config?.optional;

  return (
    <FormControlLabel
      control={<Checkbox />}
      label={
        <Typography variant="subtitle1" fontWeight="medium">
          {label}
          {!optional && <span style={{ color: "red" }}>*</span>}
        </Typography>
      }
    />
  );
};
export default CheckboxFieldPreview;
